import { Skeleton } from "@/components/ui/skeleton";

export function DashboardSkeleton() {
  return (
    <div className="p-4 space-y-4">
      {/* KPI Cards */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="rounded-lg border p-4 space-y-2">
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-8 w-16" />
            <Skeleton className="h-3 w-24" />
          </div>
        ))}
      </div>

      {/* Filter Bar */}
      <div className="flex gap-2">
        <Skeleton className="h-9 w-32" />
        <Skeleton className="h-9 w-32" />
        <Skeleton className="h-9 w-24" />
      </div>

      {/* Kanban Columns */}
      <div className="grid grid-cols-3 md:grid-cols-5 lg:grid-cols-8 gap-2">
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="rounded-lg border p-2 space-y-2 min-h-[300px]">
            <div className="flex items-center gap-2 pb-2 border-b">
              <Skeleton className="h-5 w-8 rounded-full" />
              <Skeleton className="h-4 w-16" />
            </div>
            {Array.from({ length: 3 - (i % 2) }).map((_, j) => (
              <Skeleton key={j} className="h-16 w-full rounded" />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export function OperatorSkeleton() {
  return (
    <div className="p-4 space-y-4">
      {/* Header */}
      <div className="flex items-center justify-between">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-9 w-32" />
      </div>

      {/* Task Cards */}
      <div className="grid gap-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="rounded-lg border p-4 space-y-3">
            <div className="flex items-center justify-between">
              <Skeleton className="h-5 w-32" />
              <Skeleton className="h-5 w-20 rounded-full" />
            </div>
            <Skeleton className="h-4 w-48" />
            <div className="flex gap-2">
              <Skeleton className="h-8 w-20" />
              <Skeleton className="h-8 w-20" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function LogisticsSkeleton() {
  return (
    <div className="p-4 space-y-4">
      {/* Tabs */}
      <div className="flex gap-2">
        <Skeleton className="h-9 w-24" />
        <Skeleton className="h-9 w-24" />
        <Skeleton className="h-9 w-24" />
      </div>

      {/* Kanban */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="rounded-lg border p-2 space-y-2 min-h-[400px]">
            <div className="flex items-center gap-2 pb-2 border-b">
              <Skeleton className="h-5 w-8 rounded-full" />
              <Skeleton className="h-4 w-20" />
            </div>
            {Array.from({ length: 4 - i }).map((_, j) => (
              <Skeleton key={j} className="h-20 w-full rounded" />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export function ArteSkeleton() {
  return (
    <div className="p-4 space-y-4">
      {/* Header */}
      <div className="flex items-center justify-between">
        <Skeleton className="h-8 w-40" />
        <div className="flex gap-2">
          <Skeleton className="h-9 w-48" />
          <Skeleton className="h-9 w-24" />
        </div>
      </div>

      {/* Kanban */}
      <div className="grid grid-cols-3 md:grid-cols-5 lg:grid-cols-8 gap-2">
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="rounded-lg border p-2 space-y-2 min-h-[350px]">
            <div className="flex items-center gap-2 pb-2 border-b">
              <Skeleton className="h-5 w-8 rounded-full" />
              <Skeleton className="h-4 w-16" />
            </div>
            {Array.from({ length: 2 }).map((_, j) => (
              <div key={j} className="rounded border p-2 space-y-2">
                <Skeleton className="h-4 w-20" />
                <Skeleton className="h-3 w-28" />
                <Skeleton className="h-3 w-16" />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
